import * as type from './constants';

export const setActivities = (data, total) => ({
  type: type.SET_ACTIVITIES,
  data,
  total,
});

export const handleLoading = status => ({
  type: type.HANDLE_LOADING,
  status,
});
